// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';
import { Box, Flex } from '../grid';
import type { Theme } from '../../types';

type Props = {
  children: Node,
  className?: string,
  justify?: string, // eslint-disable-line react/require-default-props
};

export const DeliveryTimeWrapper = styled<any, Theme>('div')`
  color: ${props => props.theme.deliveryTime.color};
  text-align: center;
  font-size: ${props => props.theme.deliveryTime.fontSize};
  margin: 0.5em 0;
`;

const DeliveryTimeText = styled<any, Theme>('span')`
  margin-left: 0.5em;
`;

const Icon = styled<any, Theme>('i')`
  font-size: 1.25rem;
`;

const DeliveryTime = ({ children, justify = 'flex-start', className }: Props) => (
  <DeliveryTimeWrapper className={className}>
    <Flex flexDirection="row" alignItems="center" justifyContent={justify}>
      <Box width="1.6rem" height="1.6rem">
        <Icon className="icon-delivery_time" />
      </Box>
      <DeliveryTimeText>{children}</DeliveryTimeText>
    </Flex>
  </DeliveryTimeWrapper>
);

DeliveryTime.defaultProps = {
  className: '',
};

export default DeliveryTime;
